import { render, staticRenderFns } from "./referee.vue?vue&type=template&id=52d9acac&scoped=true"
import script from "./referee.vue?vue&type=script&lang=js"
export * from "./referee.vue?vue&type=script&lang=js"
import style0 from "./referee.vue?vue&type=style&index=0&id=52d9acac&prod&lang=less"
import style1 from "./referee.vue?vue&type=style&index=1&id=52d9acac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9acac",
  null
  
)

export default component.exports